//
// Copyright (c) 2011-2019 by Curalate, Inc.
//

import { createSelector } from 'reselect';

import { splitMentionedItemsCombiner } from '@galleries/selectors/splitMentionedItemsCombiner';
import { ICuralateStore } from '@models/AppState';
import { getHasMultiHandleInstagramEnabled } from '@account-settings/redux/facebook-instagram/selectors/getMultiHandleFeature';

export const splitMentionedItems = createSelector(
  (state: ICuralateStore) =>
    state.galleries.requestRightsModal.materializedItems,
  (state: ICuralateStore) => state.instagram.account.defaultInstagramAccount,
  (state: ICuralateStore) =>
    state.facebookInstagramSettings.connectedInstagramAccounts,
  (state: ICuralateStore) => getHasMultiHandleInstagramEnabled(state),
  splitMentionedItemsCombiner,
);
